import React from 'react';
import ContentCard from 'components/common/general/layouts/ContentCard';
import AnswerOption, { MedicalHistoryAnswer } from '../AnswerOption';
import {
  ContentHeaderStyled,
  ContentTitleStyled,
  ContentSubtitleStyled,
  AnswersSectionWrapperStyled,
  RadioGroupStyled,
} from '../styles';

const radioButtons: Array<{
  label: string;
  value: MedicalHistoryAnswer;
  id: string;
  key: string;
}> = [
  {
    label: 'Yes',
    value: 'yes',
    id: 'medical-history-yes',
    key: 'medical-history-yes',
  },
  {
    label: 'No',
    value: 'no',
    id: 'medical-history-no',
    key: 'medical-history-no',
  },
];

interface MedicalHistoryEntryCardProps {
  selectedValue: MedicalHistoryAnswer | '';
  onChange: (hasMedicalConditions: boolean) => void;
}

export const MedicalHistoryEntryCard: React.FC<MedicalHistoryEntryCardProps> = ({ selectedValue, onChange }) => {
  const handleRadioGroupChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    onChange(e.target.value === 'yes');
  };

  return (
    <ContentCard minHeight="40rem">
      <ContentHeaderStyled>
        <ContentTitleStyled>Medical History</ContentTitleStyled>
        <ContentSubtitleStyled>
          Have you or any of your dependents had any medical conditions, surgeries, or regular prescriptions in the past
          5 years?
        </ContentSubtitleStyled>
      </ContentHeaderStyled>
      <AnswersSectionWrapperStyled>
        <RadioGroupStyled
          value={selectedValue}
          onChange={handleRadioGroupChange}
          radioButtons={radioButtons.map((button) => ({
            ...button,
            label: <AnswerOption answer={button.value} />,
          }))}
        />
      </AnswersSectionWrapperStyled>
    </ContentCard>
  );
};
